<template>
    <div class="ia-section">
        <div class="ia-content">
            <h2 class="ia-title fuente-posm">
                IA para afinar la estrategia.
            </h2>
            <p class="ia-text fuente-nova">
                Con nuestra conexión a IA especializada, analizamos cada comentario para detectar patrones que el ojo humano no ve.
                <br><br>
                Enviaremos un reporte especial cuando se detecten problemas recurrentes en la atención de tu equipo, productos y horarios.
            </p>
        </div>
        <div class="ia-image">
            <img :src="a49" alt="IA Feedback">
        </div>
    </div>
</template>

<script>
export default {
    name: 'IAFeedbackNew',
    data() {
        return {
            a49: require('@/assets/images/a46.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.ia-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
    background-color: #272727;
}

.ia-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.ia-image img {
    width: 450px;
    height: auto;
}

.ia-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.ia-title {
    color: var(--color-5);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.ia-text {
    color: var(--color-5);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .ia-title {
        font-size: 60px;
    }

    .ia-text {
        font-size: 27px;
    }

    .ia-image img {
        width: 350px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .ia-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .ia-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .ia-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .ia-image img {
        width: 90%;
        max-width: 350px;
    }

    .ia-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .ia-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
